import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  switch(event) {
    const selectedPanel = event.params.panel

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tabsName !== selectedPanel)
    })

    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tabsPanelParam === selectedPanel
      tab.classList.toggle("border-train-yellow", isActive)
      tab.classList.toggle("text-train-yellow", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
    })
  }
}
